import { Component, effect, input, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormArray } from '@angular/forms';

@Component({
    selector: 'app-glossary',
    templateUrl: './glossary.component.html',
    styleUrls: ['./glossary.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class GlossaryComponent {
    readonly model = input<any>();
    readonly meta = input<any>();
    readonly formGroup = input<FormGroup<any>>();

    glossaryArray: FormArray<any> =new FormArray<any>([]);

    constructor(
    ) {
        effect(() => {
            const model = this.model();
            const formGroup = this.formGroup();

            if (model && formGroup) {
                formGroup.addControl('headers', this.glossaryArray);
                this.loadOptions();
            }
        });
    }

    onAddField() {
        const model = this.model();

        if (model && this.glossaryArray) {
            if (!model.headers) {
                model.headers = [];
            }
            model.headers.push({});
            this.glossaryArray.push(new FormGroup({}));
        }
    }

    onDelete($event: any) {
        const model = this.model();
        if (!model?.headers) {
            return;
        }
        const index = model.headers?.findIndex((x: any) => x === $event);
        model.headers.splice(index, 1);
        this.glossaryArray?.removeAt(index);
    }

    private loadOptions() {
        this.glossaryArray.clear();
        const model = this.model();
        if (model?.headers?.length && this.glossaryArray) {
            for (const header of model.headers) {
                this.glossaryArray.push(new FormGroup({}));
            }
        }
    }
}
